import { Component, Input, ChangeDetectionStrategy, EventEmitter, Output, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

// Import necessary NG-ZORRO modules
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTypographyModule } from 'ng-zorro-antd/typography'; // Good for consistent text styling
import { ColorConfig } from '../../utils/shared';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RappiderCheckboxModule } from '../checkbox/checkbox.module';
import { FormsModule } from '@angular/forms';

export interface CardTag {
  iconName?: string | undefined; // Optional icon for the tag
  text: string;
  color?: string | undefined; // Optional color for the tag
}

@Component({
  selector: 'rappider-card-icon-title-description',
  standalone: true,
  imports: [
    CommonModule,
    NzCardModule,
    NzIconModule,
    NzTypographyModule,
    NzTagModule,
    NzToolTipModule,
    RappiderCheckboxModule,
    FormsModule
  ],
  templateUrl: './card-icon-title-description.component.html',
  styleUrls: ['./card-icon-title-description.component.scss'],
})
export class RappiderCardWithIconTitleDescriptionComponent {
  @Input() id = '';
  @Input() title = '';
  @Input() key? = '';
  @Input() iconName? = 'fa fa-regular fa-star';
  @Input() tags?: CardTag[] = [];
  @Input() description?: string | undefined;
  @Input() color?: ColorConfig;
  @Input() customCardContainerCssClass?: string = '';
  @Input() isCheckable?: boolean = false;
  @Input() isCheck?: boolean = false;
  @Input() customTemplate!: TemplateRef<any>;
  @Input() templateData: any;
  /* Displays a compact / smaller card with less padding and h6 title  */
  @Input() compactCard? = false;

  @Output() cardClick = new EventEmitter<{ id: string; title: string; key?: string; }>();
  @Output() checkboxValueChange = new EventEmitter();

  onCardClick() {
    this.cardClick.emit({ id: this.id, title: this.title, key: this.key });
  }

  onCheckboxValueChange(isCheck) {
    this.checkboxValueChange.emit({ check: isCheck, id: this.id });
  }
}
